// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__L48Nr","text":"menu_text__vpBuT"};